import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import jiyeonko from "../img/jiyeonko.png";
import Back from "../img/Home_back.png";
import sukhyonkim from "../img/sukhyonkim.png";
const One_div = styled.div`
  display : inline-block;
  width : 50%;
`
const Two_div = styled.div`
  display : inline-block;
  width : 50%;
  text-align : right ;
`
function People_item_2 (){
    return (
      
      <Category_wrapper>
            <Content_span>
              Data Scientists
            </Content_span>
            <Content_span>
              Administrative<br/>Staff
            </Content_span>
          <Item_wrapper>
            <One_div>
            <Category_list_ul>
          <Category_list_li>
            <Item_img src={jiyeonko}/>
            <Item_content_wrapper>
                <Item_span_title>
                  Ji Yeon, Ko
                </Item_span_title>
                <Item_content>
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
        </Category_list_ul>

            </One_div>
            <Two_div>
              
        <Category_list_ul>
          <Category_list_li>
            <Item_img src={sukhyonkim}/>
            <Item_content_wrapper>
                <Item_span_title>
                Suk Hyon Kim
                </Item_span_title>
                <Item_content>
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
        </Category_list_ul>
            </Two_div>
        </Item_wrapper>
      </Category_wrapper>
    )
  }
  const Item_wrapper = styled.div`
  width : 880px;
  margin : 50px auto;
  `
  const Item_content_wrapper = styled.div`
    padding : 5px 10px;
    text-align : left;
  `
  const Item_span_title = styled.div`
    font-weight : bold;
    font-size : 15px;
    text-align : center;
    padding : 10px 5px ;
    font-family: "People_name";        
  `
  const Item_content = styled.div`
    font-size : 10px;
    text-align : center;
    padding : 0 5px ;
    
  `
  const Item_img = styled.img`
  width : 160px;
  height :160px; 
    margin : 15px;
    border-radius : 100%;
  `
  const Category_wrapper = styled.div`
    width : 1200px;
    margin : 0px auto;
    padding : 50px 0;
    background : url(${Back});
    background-size : 1700px;
    background-position-x : 1252px;
    position : relative;
    `
    const Category_list_ul=styled.ul`
    font-family: "Ko";        
    display : inline-block;
    `
    const Category_list_li = styled.li`
      display : block;
      width : 200px;
      height :320px;
      text-align : center;
      vertical-align : top;
      box-shadow: 5px 3px 5px rgba(70, 70, 70, 0.2);
      background: white;
      
      `
  const Content_span = styled.span`
  font-family: "Title";        
    display : block;
    font-size : 35px; 
    font-weight : bold; 
    box-sizing : border-box;
    position: absolute;
    &:nth-child(1){
      left : 32%;
      bottom : 120px;
    }
    &:nth-child(2){
      right : 32%;
      top:120px;
      text-align : right ;
    }
  `
  const Content_span2 = styled.span`
  display : inline-block;
  font-size : 20px; 
  margin: 20px 0; 
  height : 30px;
  `
  const Span_div = styled.div`
    display : inline-block;
    width : 390px;
    text-align : left; 
  `
  
  export default People_item_2;